export default __webpack_public_path__ + "static/media/america_text.b63a1440.png";